export default __webpack_public_path__ + "static/media/3 (2000).b9c2f173.jpg";